/**
 * Render a recovery action even when React, providers, or styles never loaded.
 * Never echo the current URL/error or clear an unfinished OAuth exchange.
 * @param {{root?: HTMLElement|null, hostname?: string, reload?: () => void}} options
 * @returns {boolean}
 */
export function renderStartupFailure({
  root = document.getElementById('root'),
  hostname = window.location.hostname,
  reload = () => window.location.reload(),
} = {}) {
  if (!root) return false;
  const doc = root.ownerDocument;
  const local = ['localhost', '127.0.0.1', '::1', '[::1]'].includes(hostname);
  const surface = doc.createElement('main');
  surface.setAttribute('role', 'alert');
  // Inline fallback styles are intentional: the application stylesheet may
  // be the failed import. Use legacy DOM APIs, not replaceChildren/innerHTML.
  surface.style.cssText = 'box-sizing:border-box;min-height:100vh;min-height:100dvh;padding:24px;background-color:#f9f8f4;color:#1c1917;font:16px/1.5 system-ui,sans-serif;';
  // Unsupported max()/var() must not discard the basic recovery styles.
  surface.style.padding = 'max(24px,var(--yoofloe-safe-area-top,var(--safe-area-inset-top,0px))) max(24px,var(--yoofloe-safe-area-right,var(--safe-area-inset-right,0px))) max(24px,var(--yoofloe-safe-area-bottom,var(--safe-area-inset-bottom,0px))) max(24px,var(--yoofloe-safe-area-left,var(--safe-area-inset-left,0px)))';

  const title = doc.createElement('h1');
  title.textContent = 'Yoofloe could not start';
  title.style.cssText = 'margin:0 0 12px;font-size:24px;line-height:1.3;color:#1c1917;';
  const message = doc.createElement('p');
  message.textContent = 'Please reload the app to try again.';
  message.style.cssText = 'max-width:40rem;margin:0 0 16px;color:#44403c;';
  surface.appendChild(title);
  surface.appendChild(message);
  const button = doc.createElement('button');
  button.type = 'button';
  button.textContent = 'Reload app';
  button.style.cssText = 'box-sizing:border-box;min-height:44px;min-width:44px;padding:10px 20px;border:1px solid #4a5d4e;border-radius:8px;background-color:#4a5d4e;color:#fff;font:600 16px/1.5 system-ui,sans-serif;cursor:pointer;';
  button.addEventListener('click', reload);
  surface.appendChild(button);
  if (local) {
    const hint = doc.createElement('p');
    hint.textContent = 'Make sure the local development server is running, then reload.';
    hint.style.cssText = 'max-width:40rem;margin:16px 0 0;color:#44403c;';
    surface.appendChild(hint);
  }
  root.textContent = '';
  root.appendChild(surface);
  return true;
}
